const NAMESPACE = "bulkUpgradeResults";

const KEYS = {
    downloadButtonLabel: "downloadButtonLabel",
    upgradeWarning: "upgradeWarning",
    analysisResultsMessage: "analysisResultsMessage",
    upgradeResultsMessage: "upgradeResultsMessage",
    failureResultMessage: "failureResultMessage",
    analysisTitle: "analysisTitle",
    failuresTitle: "failuresTitle",
    successTitle: "successTitle"
};

const MESSAGES = {
    [KEYS.downloadButtonLabel]: {
        value: "Download Results",
        comment: "Label for button to download results"
    },
    [KEYS.upgradeWarning]: {
        value: "Some templates cannot be upgraded automatically. You will need to fix or remove some existing tags in the following templates either because they are invalid, they attempt to reference a field that cannot be found, or they attempt to reference a field that has been archived:",
        comment: "Message to user about what templates contain broken or invalid tags"
    },
    [KEYS.analysisResultsMessage]: {
        value: "Finished analyzing templates. {successCount} of {totalCount} templates can be upgraded with no intervention.",
        comment: "Results with count of template analysis"
    },
    [KEYS.upgradeResultsMessage]: {
        value: "Successfully upgraded {successCount} of {totalCount} templates.",
        comment: "Results with count of template upgrades"
    },
    [KEYS.failureResultMessage]: {
        value: "Manual intervention required to upgrade {failCount} templates.",
        comment: "Count of failures from template upgrade attempt"
    },
    [KEYS.analysisTitle]: {
        value: "Template Analysis Complete",
        comment: "Title for alert when only analyzing tags"
    },
    [KEYS.failuresTitle]: {
        value: "Manual Intervention Required",
        comment: "Title for alert when errors are found"
    },
    [KEYS.successTitle]: {
        value: "Bulk Upgrade Successful",
        comment: "Title for alert when upgrade succeeds without error"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
